module.exports = __webpack_public_path__ + "img/bancontact.f842c3fd.png";